import React, { useEffect, useRef, useState } from "react";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import InvoiceTab from "./InvoiceTab";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import {
  defaultPageRowOptions,
  defaultRowOptions,
  paginatorLinks,
  paymentMethodOptions,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
} from "../../appconfig/Settings";
import { Column } from "primereact/column";
import { InvoicePayeeListColumn } from "../../appconfig/DatatableSetting";
import { deleteData, getAllDetails, postAllData, updateData } from "../../service/ProductService";
import { DELETE_INVOICE_PAYEE, GET_INVOICE_PAYEE_LIST, SAVE_INVOICE_PAYEE_DATA } from "../../config/ApiConstant";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { validateInvoicePayeeForm } from "../../config/Validate";
import { useLocation, useNavigate } from "react-router-dom";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { globalNameFilterTemplate } from "../../appconfig/AppHelper";

const InvoicePayee = () => {
  document.title = "Invoice Payee | Nexawage";

  const location: any = useLocation();

  const clientParamId = location?.state?.clientId;

  const toast = useRef<any>(null);
  const navigate = useNavigate();

  // state for business number to display static
  const [displayBusinessNumber, setDisplayBusinessNumber] = useState("");

  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;
  const userRole = userData?.roles?.role_name || "";

  // filter
  const emptyFilters = {
    global: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    bill_email: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    phone: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
  };
  const [filters, setFilters] = useState(emptyFilters);

  // client id based on login
  let clientId: any = null;
  if (userRole === "User") {
    clientId = clientParamId;
  } else {
    clientId = userData?.id;
  }

  //   filter
  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);

  const [pageLoad, setPageLoad] = useState<boolean>(false);
  const [payeeList, setPayeeList] = useState<any>([]);
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);

  // isedit true false
  const [isEdit, setIsEdit] = useState<boolean>(false);

  // error state
  const [errors, setErrors] = useState<any>({});

  //   payee add and edit state
  const [payeeUserData, setPayeeUserData] = useState<any>({});

  //   add edit payee dailod
  const [addEditPayeeDialog, setAddEditPayeeDialog] = useState<boolean>(false);

  // selected Row id
  const [selectedRowId, setSelectedRowId] = useState<any>(null);

  // Delete dialog
  const [deleteDialog, setDeleteDialog] = useState<boolean>(false);

  //   useEffect to get Payeelist
  useEffect(() => {
    getPayeeList();
  }, []);

  // setting business number for display purpose static
  useEffect(() => {
    if (payeeUserData.business_no) {
      const val = payeeUserData.business_no;
      const firstNine = val.slice(0, 9);
      const rest = val.slice(9);
      const displayVal = val.length > 9 ? `${firstNine}RP${rest}` : val;
      setDisplayBusinessNumber(displayVal);
    }
  }, [payeeUserData.business_no]);

  // onchange
  const onInputChange = (e: any, name: string) => {
    let val = e.target.value ?? e.value;

    // format Business number
    if (name === "business_no") {
      // remove spaces and RP
      const cleanVal = val.replace(/\s+/g, "").replace("RP", "");

      // create display version
      let displayVal = cleanVal;
      if (cleanVal.length > 9) {
        const firstNine = cleanVal.slice(0, 9);
        const rest = cleanVal.slice(9);
        displayVal = `${firstNine}RP${rest}`;
      }

      // update what user sees in input
      setDisplayBusinessNumber(displayVal);

      // update your global state with clean (no RP)
      setPayeeUserData({
        ...payeeUserData,
        business_no: cleanVal,
      });

      return;
    }

    if (name === "payment_type") {
      setPayeeUserData({
        ...payeeUserData,
        [name]: val,
        payment_info: "",
        bank_name: "",
        institution_number: "",
        transit_number: "",
        bank_account_number: "",
      });
      setErrors({
        ...errors,
        [name]: "",
        payment_info: "",
        bank_name: "",
        institution_number: "",
        transit_number: "",
        bank_account_number: "",
      });
      return;
    }

    setPayeeUserData({ ...payeeUserData, [name]: val });
    setErrors({ ...errors, [name]: "" });
  };

  // hide add & edit payee modal
  const hideAddEditPayeeDialog = () => {
    setAddEditPayeeDialog(false);
    setSubmitLoading(false);
  };

  //   get payee list api call
  const getPayeeList = async () => {
    try {
      setPageLoad(false);

      const response = await getAllDetails(`${GET_INVOICE_PAYEE_LIST}/${clientId}`);
      setPayeeList(response);
      setPageLoad(true);
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // add and edit payee modal
  const addEditDialog = (rowData: any = null) => {
    if (rowData) {
      let parsedRowData = { ...rowData };

      if (rowData.payment_info) {
        let parsedInfo = rowData.payment_info;
        if (typeof parsedInfo === "string") {
          try {
            parsedInfo = JSON.parse(parsedInfo);
          } catch (e) { }
        }

        if (typeof parsedInfo === "object" && parsedInfo !== null) {
          if (rowData.payment_type === "bank_transfer") {
            parsedRowData.bank_name = parsedInfo.bank_name;
            parsedRowData.institution_number = parsedInfo.institution_number;
            parsedRowData.transit_number = parsedInfo.transit_number;
            parsedRowData.bank_account_number = parsedInfo.bank_account_number;
            parsedRowData.payment_info = ""; // Clear so it doesn't break InputText
          } else {
            // For other payment types, extract the specific detail back into payment_info string
            let extractedInfo = parsedInfo.email || parsedInfo.payment_link || parsedInfo.detail || "";
            if (rowData.payment_type === "other" && extractedInfo) {
              extractedInfo = extractedInfo.replace(/<br\s*\/?>/gi, '\n');
            }
            parsedRowData.payment_info = extractedInfo;
          }
        }
      }

      setPayeeUserData(parsedRowData);
      setIsEdit(true);
    } else {
      setPayeeUserData({});
      setIsEdit(false);
      setDisplayBusinessNumber("");
    }
    setErrors({});
    setAddEditPayeeDialog(true);
  };

  // submit payee form
  const submitPayeeForm = async () => {
    const { isError, errors } = validateInvoicePayeeForm(payeeUserData);
    setErrors(errors);
    if (isError) return;

    setSubmitLoading(true);
    try {
      let finalPaymentInfo = payeeUserData?.payment_info;
      if (payeeUserData?.payment_type === "bank_transfer") {
        finalPaymentInfo = JSON.stringify({
          bank_name: payeeUserData?.bank_name,
          institution_number: payeeUserData?.institution_number,
          transit_number: payeeUserData?.transit_number,
          bank_account_number: payeeUserData?.bank_account_number,
        });
      } else if (payeeUserData?.payment_type) {
        // Wrap other payment types in a JSON object too
        const keyMap: Record<string, string> = {
          e_transfer: "email",
          payment_link: "payment_link",
          other: "detail",
        };
        const key = keyMap[payeeUserData.payment_type] || "detail";

        let infoValue = payeeUserData?.payment_info || "";
        if (payeeUserData.payment_type === "other") {
          infoValue = infoValue.replace(/\n/g, '<br/>');
        }

        finalPaymentInfo = JSON.stringify({
          [key]: infoValue,
        });
      }

      const payload = {
        client_id: clientId,
        bill_to: payeeUserData?.bill_to,
        bill_email: payeeUserData?.bill_email,
        bill_phone: payeeUserData?.bill_phone,
        bill_address: payeeUserData?.bill_address,
        business_no: payeeUserData?.business_no,
        payment_type: payeeUserData?.payment_type,
        payment_info: finalPaymentInfo,
        ...(isEdit && { id: payeeUserData?.id }),
      };

      const response = await postAllData(SAVE_INVOICE_PAYEE_DATA, payload);

      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });
        hideAddEditPayeeDialog();
        getPayeeList();
        setDisplayBusinessNumber("");
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  // clear all fields
  const ClearAll = () => {
    setFilters({ ...emptyFilters });
    setGlobalFilter(null);
    setGlobalFieldFilter(null);
  };

  //   left toolbar template
  const leftToolbarTemplate = () => (
    <>
      <span className="block mr-2 p-input-icon-left">
        <i className="pi pi-search" />
        <InputText type="search" value={globalFilter || ""} onChange={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
      </span>
    </>
  );

  //   right toolbar template
  const rightToolbarTemplate = () => (
    <>
      <div style={{ display: "flex", alignItems: "end" }}>
        <Button icon="pi pi-filter-slash" label="Clear" onClick={ClearAll} className="mr-3  p-button-outlined common-p-outline-button" />
      </div>
      <Button label="Add New Payee" icon="pi pi-plus" className="p-button-primary" onClick={() => addEditDialog()} />
    </>
  );

  // delete confirmation modal
  const confirmDelete = (deleteID: any) => {
    setSelectedRowId(deleteID);
    setDeleteDialog(true);
  };

  // delete employee api call
  const deletePayee = async () => {
    try {
      setSubmitLoading(true);
      const response = await deleteData(DELETE_INVOICE_PAYEE, selectedRowId);
      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Deleted",
          detail: response.message,
        });
        hideDeleteDialog();
        getPayeeList();
        setSubmitLoading(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setSubmitLoading(false);
    }
  };

  // hide delete modal
  const hideDeleteDialog = () => {
    setDeleteDialog(false);
    setSelectedRowId(null);
  };

  // action body template
  const actionBodyTemplate = (rowData: any) => (
    <div className="actions">
      <Button
        icon="pi pi-pencil"
        tooltip="Edit"
        className="common-edit-btn"
        tooltipOptions={{ position: "bottom" }}
        onClick={() => addEditDialog(rowData)}
      />

      <Button
        icon="pi pi-trash"
        tooltipOptions={{ position: "bottom" }}
        className="ml-2 p-button-danger common-delete-btn"
        tooltip="Delete"
        onClick={() => confirmDelete(rowData.id)}
      />
    </div>
  );

  // create invoice template
  const createInvoiceTemplate = (rowData: any) => {
    return (
      <div className="name">
        <Button
          tooltip={"Create Invoice"}
          tooltipOptions={{ position: "bottom" }}
          className="ml-2 common-primary-button"
          icon="pi pi-plus"
          label=""
          onClick={() =>
            navigate(`/invoice/${btoa(rowData?.id)}`, {
              state: { clientId: clientId },
            })
          }
        />
      </div>
    );
  };

  // business no template
  const businessNumberTemplate = (rowData: any) => (
    <div className="name">{rowData?.business_no ? rowData.business_no.slice(0, 9) + " RP " + rowData.business_no.slice(-4) : "-"}</div>
  );

  return (
    <>
      <AppBreadcrumb currentMenu={"Payee"} pageName={"Detail"} pageTitle={"Payee"} goToPage={userRole === "User"} />
      <div className="grid crud-demo">
        <div className="col-12">
          <Card className="bg-white crud-demo lg:p-2">
            <InvoiceTab index={0} id={clientId} />
            <Toast ref={toast} />
            <Toolbar className="gap-3" left={leftToolbarTemplate} right={rightToolbarTemplate} />

            {pageLoad ? (
              <DataTable
                value={payeeList}
                showGridlines
                dataKey="id"
                stripedRows
                globalFilter={globalFilter}
                rows={defaultRowOptions}
                paginator={payeeList?.length > 0}
                rowsPerPageOptions={defaultPageRowOptions}
                className="datatable-responsive p-datatble-sm"
                paginatorTemplate={paginatorLinks}
                currentPageReportTemplate={showingEntries + " Payee List"}
                emptyMessage="No Data Found"
                filters={globalFieldFilter}
                onFilter={(e) => setGlobalFieldFilter(e.filters)}
                removableSort
                responsiveLayout={"scroll"}
              >
                {InvoicePayeeListColumn.map((col, i) => {
                  if (col.field === "action") {
                    return <Column key={col.field} field={col.field} header={col.header} body={actionBodyTemplate} />;
                  } else if (col.field === "create_invoice") {
                    return <Column key={col.field} field={col.field} header={col.header} body={createInvoiceTemplate} />;
                  } else if (col.field === "business_no") {
                    return <Column key={col.field} field={col.field} header={col.header} body={businessNumberTemplate} />;
                  } else {
                    return <Column key={col.field} field={col.field} header={col.header} />;
                  }
                })}
              </DataTable>
            ) : (
              <DataTable value={Skeletonitems}>
                {InvoicePayeeListColumn.map((col, i) => (
                  <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                ))}
              </DataTable>
            )}
          </Card>
        </div>
      </div>

      {/* Add/Edit payee Dialog */}
      <Dialog
        visible={addEditPayeeDialog}
        className="mx-3 lg:mx-0"
        style={{ width: "800px" }}
        header={isEdit ? "Edit Payee Detail" : "Add Payee"}
        draggable={false}
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" onClick={hideAddEditPayeeDialog} />
            <Button label="Submit" icon="pi pi-check" onClick={submitPayeeForm} className="common-primary-button" loading={submitLoading} />
          </div>
        }
        onHide={hideAddEditPayeeDialog}
      >
        <div className="grid p-fluid formgrid">
          {/* Bill To Name */}
          <div className="field col-12 md:col-6">
            <label htmlFor="name">Bill To *</label>
            <div className="input-effect-div">
              <InputText
                value={payeeUserData.bill_to || ""}
                name="bill_to"
                autoComplete="off"
                placeholder="Enter Bill To Name"
                onChange={(e) => onInputChange(e, "bill_to")}
                className={errors["bill_to"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["bill_to"]}</small>
          </div>

          {/* Email */}
          <div className="field col-12 md:col-6">
            <label htmlFor="email">Email *</label>
            <div className="input-effect-div">
              <InputText
                value={payeeUserData.bill_email || ""}
                name="bill_email"
                autoComplete="off"
                placeholder="Enter Email"
                onChange={(e) => onInputChange(e, "bill_email")}
                className={errors["bill_email"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["bill_email"]}</small>
          </div>

          {/* Phone */}
          <div className="field col-12 md:col-6">
            <label htmlFor="phone">Phone *</label>
            <div className="flex-1 input-effect-div p-inputgroup">
              <span className="font-bold p-inputgroup-addon">+1</span>
              <InputText
                value={payeeUserData.bill_phone || ""}
                name="bill_phone"
                autoComplete="off"
                placeholder="Enter Phone Number"
                onChange={(e) => onInputChange(e, "bill_phone")}
                className={errors["bill_phone"] && "p-invalid"}
                keyfilter="pint"
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["bill_phone"]}</small>
          </div>

          {/* Buisness Number */}
          <div className="field col-12 md:col-6">
            <label htmlFor="business_no">Business No</label>
            <div className="input-effect-div">
              <InputText
                value={displayBusinessNumber || ""}
                name="business_no"
                autoComplete="off"
                placeholder="Enter Business Number"
                maxLength={15}
                keyfilter={"pint"}
                onChange={(e) => onInputChange(e, "business_no")}
                className={errors["business_no"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["business_no"]}</small>
          </div>

          {/* Address */}
          <div className="field col-12 md:col-12">
            <label htmlFor="address">Address *</label>
            <div className="input-effect-div">
              <InputTextarea
                rows={2}
                value={payeeUserData.bill_address || ""}
                name="bill_address"
                autoComplete="off"
                placeholder="Enter Address"
                onChange={(e) => onInputChange(e, "bill_address")}
                className={errors["bill_address"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["bill_address"]}</small>
          </div>

          {/* Payment Method */}
          <div className="field col-12 md:col-6">
            <label htmlFor="payment_type">Payment Method *</label>
            <div className="input-effect-div">
              <Dropdown
                value={payeeUserData?.payment_type || ""}
                options={paymentMethodOptions}
                onChange={(e) => onInputChange(e, "payment_type")}
                placeholder="Select Payment Method"
                className={errors["payment_type"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["payment_type"]}</small>
          </div>

          {/* Conditional Payment Method Detail */}
          {payeeUserData?.payment_type && payeeUserData?.payment_type !== "bank_transfer" && (
            <div className={`field col-12 ${payeeUserData.payment_type === "other" ? "md:col-12" : "md:col-6"}`}>
              <label htmlFor="payment_info">
                {payeeUserData.payment_type === "e_transfer" && "E-transfer Email *"}
                {payeeUserData.payment_type === "payment_link" && "Payment Link *"}
                {payeeUserData.payment_type === "other" && "How to pay *"}
              </label>
              <div className="input-effect-div">
                {payeeUserData.payment_type === "other" ? (
                  <InputTextarea
                    rows={2}
                    value={payeeUserData.payment_info || ""}
                    name="payment_info"
                    autoComplete="off"
                    placeholder="Enter Detail"
                    onChange={(e) => onInputChange(e, "payment_info")}
                    className={errors["payment_info"] && "p-invalid"}
                  />
                ) : (
                  <InputText
                    value={payeeUserData.payment_info || ""}
                    name="payment_info"
                    autoComplete="off"
                    placeholder="Enter Email"
                    onChange={(e) => onInputChange(e, "payment_info")}
                    className={errors["payment_info"] && "p-invalid"}
                  />
                )}
                <span className="focus-bg"></span>
              </div>
              <small className="p-invalid-txt">{errors["payment_info"]}</small>
            </div>
          )}

          {/* Conditional Bank Transfer Detail */}
          {payeeUserData?.payment_type === "bank_transfer" && (
            <>
              <div className="field col-12 md:col-6">
                <label htmlFor="bank_name">Bank Name *</label>
                <div className="input-effect-div">
                  <InputText
                    value={payeeUserData.bank_name || ""}
                    name="bank_name"
                    autoComplete="off"
                    placeholder="Enter Bank Name"
                    onChange={(e) => onInputChange(e, "bank_name")}
                    className={errors["bank_name"] && "p-invalid"}
                  />
                  <span className="focus-bg"></span>
                </div>
                <small className="p-invalid-txt">{errors["bank_name"]}</small>
              </div>
              <div className="field col-12 md:col-6">
                <label htmlFor="institution_number">Institution Number *</label>
                <div className="input-effect-div">
                  <InputText
                    value={payeeUserData.institution_number || ""}
                    name="institution_number"
                    autoComplete="off"
                    placeholder="Enter Institution Number"
                    keyfilter="pint"
                    maxLength={3}
                    onChange={(e) => onInputChange(e, "institution_number")}
                    className={errors["institution_number"] && "p-invalid"}
                  />
                  <span className="focus-bg"></span>
                </div>
                <small className="p-invalid-txt">{errors["institution_number"]}</small>
              </div>
              <div className="field col-12 md:col-6">
                <label htmlFor="transit_number">Transit Number *</label>
                <div className="input-effect-div">
                  <InputText
                    value={payeeUserData.transit_number || ""}
                    name="transit_number"
                    autoComplete="off"
                    placeholder="Enter Transit Number"
                    keyfilter="pint"
                    maxLength={5}
                    onChange={(e) => onInputChange(e, "transit_number")}
                    className={errors["transit_number"] && "p-invalid"}
                  />
                  <span className="focus-bg"></span>
                </div>
                <small className="p-invalid-txt">{errors["transit_number"]}</small>
              </div>
              <div className="field col-12 md:col-6">
                <label htmlFor="bank_account_number">Account Number *</label>
                <div className="input-effect-div">
                  <InputText
                    value={payeeUserData.bank_account_number || ""}
                    name="bank_account_number"
                    autoComplete="off"
                    placeholder="Enter Account Number"
                    keyfilter="pint"
                    maxLength={12}
                    onChange={(e) => onInputChange(e, "bank_account_number")}
                    className={errors["bank_account_number"] && "p-invalid"}
                  />
                  <span className="focus-bg"></span>
                </div>
                <small className="p-invalid-txt">{errors["bank_account_number"]}</small>
              </div>
            </>
          )}
        </div>
      </Dialog>

      {/* Delete Dialog */}
      <Dialog
        visible={deleteDialog}
        header="Delete Payee"
        draggable={false}
        className="mx-3 lg:mx-0"
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" onClick={hideDeleteDialog} />
            <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deletePayee} loading={submitLoading} />
          </div>
        }
        onHide={hideDeleteDialog}
      >
        <div className="flex align-items-center justify-content-start">
          <i className="mr-3 pi pi-exclamation-triangle delete-triangle" style={{ fontSize: "2rem" }} />
          <span className="delete-dialog-note">Are you sure you want to delete this Payee ?</span>
        </div>
      </Dialog>
    </>
  );
};

export default InvoicePayee;
